import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ListNumberedIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M5.623 16.89c.524 0 .802.595.506.994l-.063.072-.928.933.074.029c.192.082.365.198.52.349l.112.119c.95 1.103.181 2.715-1.086 2.919-.861.138-1.65-.184-2.25-.954a.625.625 0 11.985-.768c.324.415.662.553 1.067.487.362-.058.602-.56.336-.869-.178-.206-.502-.261-1.079-.1-.587.166-1.02-.513-.673-.971l.061-.07.914-.92h-.942a.625.625 0 01-.618-.532l-.007-.093c0-.314.232-.573.533-.618l.092-.007h2.446zM22 18a1 1 0 01.117 1.993L22 20H10a1 1 0 01-.117-1.993L10 18h12zM4.222 8.897c.573 0 .994.12 1.381.46.694.613.943 1.64.22 2.699-.223.327-.485.6-.935 1.002l-.705.625-.108.1h1.704c.314 0 .574.232.619.533l.006.092a.625.625 0 01-.532.619l-.093.006H3a.625.625 0 01-.625-.625c0-.388.159-.742.44-1.096l.145-.175c.129-.146.271-.283.55-.53l.666-.59c.301-.276.48-.469.615-.666.329-.481.245-.827-.015-1.056-.124-.11-.258-.148-.554-.148-.317 0-.597.36-.597.853a.625.625 0 11-1.25 0c0-1.125.761-2.103 1.847-2.103zM22 11a1 1 0 01.117 1.993L22 13H10a1 1 0 01-.117-1.993L10 11h12zM4.272 1.709c.314 0 .573.231.618.533l.007.092V6.59a.625.625 0 01-1.243.093l-.007-.093-.001-3.133-.589.504a.625.625 0 01-.809.002l-.072-.072a.625.625 0 01-.002-.809l.072-.072L3.594 1.86c.09-.078.2-.127.318-.144L4 1.71h.272zM22 4a1 1 0 01.117 1.993L22 6H10a1 1 0 01-.117-1.993L10 4h12z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
ListNumberedIcon.isCarinaIcon = true;
export default ListNumberedIcon;
